import React, { Component } from 'react';

require('./socialMediaShareLinks.css')

const LinkedinIcon = require('../../assets/img/svg/linked-in-black.svg');
const TwitterIcon = require('../../assets/img/svg/twitter-black.svg');
const FacebookIcon = require('../../assets/img/svg/fb-black.svg');
const MailToIcon = require('../../assets/img/svg/mail-to-black.svg');

class SocialMediaShareLinks extends Component {

	constructor(props) {
		super(props);
		this.state = {

		};
	}

	render() {
		const linkedinURL = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`;
		// var twitterURL = "http://twitter.com/home?status=" + encodeURIComponent(this.props.jsonConfig.socialMediaIconsTitle) + "+" + encodeURIComponent(window.location.href);
		const twitterURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`;
		const facebookURL = `https://www.facebook.com/share.php?u=${encodeURIComponent(window.location.href)}`;
		const mailToUrl = `mailto:${this.props.jsonConfig.emailId}?body=How far is your company on its digital journey%3F Take Bain's Digital Readiness Assessment https://www.survey.bain.com/digitalreadiness/`;
		return (
			<div className="Social-media-icons">
				<a href={mailToUrl} target="_blank" rel="noopener noreferrer">
					<img src={MailToIcon} className="IconEmailTo" alt="Email Us" title="Email Us" />
				</a>
				<a href={linkedinURL} target="_blank" rel="noopener noreferrer">
					<img src={LinkedinIcon} className="IconLinkedIn" alt="Share on LinkedIn" title="Share on LinkedIn" />
				</a>
				<a href={twitterURL} target="_blank" rel="noopener noreferrer">
					<img src={TwitterIcon} className="IconTwitter" alt="Share on Twitter" title="Share on Twitter" />
				</a>
				<a href={facebookURL} target="_blank" rel="noopener noreferrer">
					<img src={FacebookIcon} className="IconFacebook" alt="Share on Facebook" title="Share on Facebook" />
				</a>
			</div>
		);
	}
}

export default SocialMediaShareLinks;



// WEBPACK FOOTER //
// ./src/components/SocialMediaShareLinks/socialMediaShareLinks.js